// const  EventBus = window.VueEventBus
import * as types from '../mutation-types/data-layer'

const namespaced = true
export const namespace = 'dataLayer'
export const rootNamespace = 'pageService'
export const absoluteNamespace = [rootNamespace, namespace, ''].join('/')

// state
const state = {}

// mutations
const mutations = {
    [types.SET_DATA](state, { varPath, value }) {
        let stateObject = state

        const parts = varPath.split('.')
        const partsSize = parts.length

        for (let i = 0; i < partsSize; i++) {
            const part = parts[i]

            if (i + 1 == partsSize) {
                stateObject[part] = value
                break
            }

            if (!stateObject[part] || typeof(stateObject[part]) != 'object') {
                stateObject[part] = {}
            }

            stateObject = stateObject[part]
        }
    },
}

// actions
const actions = {
}

// getters
const getters = {
}

export default {
    namespaced,
    namespace,
    state,
    mutations,
    actions,
    getters,
}